import AlertDialog from 'ub/ui/alert-dialog';
import React from 'react';

const ActionBar = ({overviewUrl, displayName}) => (
  <a href={overviewUrl} className="save button modal-button action push-left">
    {`Return to ${displayName} Overview`}
  </a>
);

ActionBar.propTypes = {
  overviewUrl: React.PropTypes.string,
  displayName: React.PropTypes.string
};

const pageLoadErrorAlert = ({
  versionNewerError, displayName, displayNameLowerCase, overviewUrl
}) => {
  let message;
  let secondaryMessage;

  if (versionNewerError) {
    message = `We're sorry, we can't load your ${displayNameLowerCase}`;
    secondaryMessage = `The ${displayNameLowerCase} that you are trying to load was created
      with a newer version of Unbounce.`;
  } else {
    message = `An error occurred while trying to load your ${displayNameLowerCase}`;
    secondaryMessage = (
      <span>
        We will look into the problem as soon as possible. Should you continue
        experiencing the problem please go to our&nbsp;
        <a
          href="http://documentation.unbounce.com/hc/en-us/requests/new"
          target="_blank"
          rel="noopener noreferrer"
        >
          Support Page »
        </a>
      </span>
    );
  }

  return new AlertDialog({
    title: `Unable to load your ${displayNameLowerCase}`,
    closeX: false,
    clickOutsideWillClose: false,
    icon: 'error',
    message,
    secondaryMessage,
    actionBar: <ActionBar overviewUrl={overviewUrl} displayName={displayName} />
  });
};

export default pageLoadErrorAlert;



// WEBPACK FOOTER //
// ./src/ui/alert-dialog/page-load-error.jsx